import React, { useState, useEffect, useRef, forwardRef } from 'react';

const CountdownTimer = forwardRef(({ resendCode, buttonText }, ref) => {
  const [seconds, setSeconds] = useState(60);
  const timerRef = useRef();

  useEffect(() => {
    ref.current = {
      reset: () => {
        clearInterval(timerRef.current);
        setSeconds(60);
        startTimer();
      },
    };

    startTimer();

    return () => {
      clearInterval(timerRef.current);
    };
  }, [ref]);

  const startTimer = () => {
    timerRef.current = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds === 0) {
          clearInterval(timerRef.current);
          return 0;
        }
        return prevSeconds - 1;
      });
    }, 1000);
  };

  return (
    <>
      {seconds === 0 ? (
        <>
          <p className="text-danger">{buttonText.VerificationCodeExpire}</p>
          <div className="resend-otp-again" onClick={resendCode}>
            <p
              className="resend-otp-red"
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
            >
              {buttonText.ResendOtp}
            </p>
          </div>
        </>
      ) : (
        <>
          <span className="span-light">{buttonText?.CodeExpiresIn} </span>
          <span id="countdowntimer" className="span-strong">
            {seconds} {buttonText?.CodeExpiresInSeconds}
          </span>
        </>
      )}
    </>
  );
});

CountdownTimer.displayName = 'CountdownTimer';

export default CountdownTimer;
